module.exports = __webpack_public_path__ + "img/springup-logo.9feb672b.svg";